// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC97qxVgxO0o0nw0parGbX9CE5PPY6tT8k",
  authDomain: "myportfolio-bc689.firebaseapp.com",
  projectId: "myportfolio-bc689",
  storageBucket: "myportfolio-bc689.appspot.com",
  messagingSenderId: "267665066540",
  appId: "1:267665066540:web:e97549f02131aab9875f89",
  measurementId: "G-MHJPLVZ1SR"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);